import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/assets/css/style.css";
import "../src/assets/css/custom.css";
import AppRoutes from "./utils/routes/AppRoutes";


function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
